// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAdxf1rjXeQOHIoEDALOjxvarDW_VvIiAQ",
  authDomain: "nutri-116fc.firebaseapp.com",
  projectId: "nutri-116fc",
  storageBucket: "nutri-116fc.firebasestorage.app",
  messagingSenderId: "160453073457",
  appId: "1:160453073457:web:2709f12c30ab2ad58a9310",
  measurementId: "G-5NDY7ERSRR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
export { auth };